export enum EInverterPhaseType {
  SINGLE_PHASE = "SINGLE_PHASE",
  THREE_PHASE = "THREE_PHASE",
  NONE = "NONE",
}
